export default __webpack_public_path__ + "static/media/delete.756bb4cc.svg";